import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import myOrders from '@/components/myOrders'
import orderDetail from '@/components/orderDetail'

Vue.use(Router)


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'myOrders',
      component: myOrders,
      meta: {
        navShow: true,
        title: '我的订单'
      }
    },
    {
      // path: '/orderDetail/:platform_user_id/:order_id',
      path: '/orderDetail',
      name: 'orderDetail',
      meta:{
        navShow: true,
        title: '订单详情'
      },
      component: orderDetail
    },
  ]
})
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title == undefined?'我的订单':to.meta.title
  next();
})

export default  router



// WEBPACK FOOTER //
// ./src/router/index.js